import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ChannelPage = lazy(() => import('../pages/channel/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/tv/:slug',
    element: <ChannelPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
